type Hook = {
  tabIndex: () => number;
};
export const useTabIndexer = (): Hook => {
  let i = 0;
  return { tabIndex: () => i++ };
};
export { Hook as UseTabIndexer };
